import React from "react";

/** Returns { start, end, label } for dashboard / analytics date scoping. */
export function usePeriodRange(period, customFrom = "", customTo = "") {
  const now = new Date();
  const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
  if (period === "today") {
    return {
      start: new Date(now.getFullYear(), now.getMonth(), now.getDate()),
      end,
      label: "Today",
    };
  }
  if (period === "week") {
    return { start: new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000), end, label: "This Week" };
  }
  if (period === "month") {
    return { start: new Date(now.getFullYear(), now.getMonth(), 1), end, label: "This Month" };
  }
  if (period === "year") {
    return { start: new Date(now.getFullYear(), 0, 1), end, label: "This Year" };
  }
  if (period === "custom" && customFrom) {
    return {
      start: new Date(customFrom),
      end: customTo ? new Date(customTo + "T23:59:59") : end,
      label: "Custom range",
    };
  }
  return { start: null, end: null, label: "All Time" };
}

export function inPeriod(dateStr, range) {
  if (!range?.start && !range?.end) return true;
  if (!dateStr) return false;
  const d = new Date(dateStr);
  if (isNaN(d)) return false;
  if (range.start && d < range.start) return false;
  if (range.end && d > range.end) return false;
  return true;
}

function PeriodFilter({ period, setPeriod, customFrom, setCustomFrom, customTo, setCustomTo, style, presets }) {
  const chips = presets || [
    ["today", "Today"],
    ["week", "Week"],
    ["month", "Month"],
    ["year", "Year"],
    ["all", "All Time"],
    ["custom", "Custom"],
  ];
  return (
    <div className="period-filter-bar" style={style}>
      <div className="chips period-filter-chips">
        {chips.map(([id, label]) => (
          <div key={id} className={`chip ${period === id ? "on" : ""}`} onClick={() => setPeriod(id)}>
            {label}
          </div>
        ))}
      </div>
      {period === "custom" && (
        <div className="period-filter-custom">
          <input className="f-input" type="date" value={customFrom} onChange={e => setCustomFrom(e.target.value)} />
          <span className="period-filter-custom-sep">to</span>
          <input className="f-input" type="date" value={customTo} onChange={e => setCustomTo(e.target.value)} />
        </div>
      )}
    </div>
  );
}

export { PeriodFilter };

export const TABLE_PERIOD_PRESETS = [
  ["today", "Daily"],
  ["month", "Monthly"],
  ["year", "Yearly"],
  ["custom", "Custom"],
];

export const DASHBOARD_PERIOD_PRESETS = TABLE_PERIOD_PRESETS;

export function useTablePeriod(initial = "month") {
  const [period, setPeriod] = React.useState(initial);
  const [customFrom, setCustomFrom] = React.useState("");
  const [customTo, setCustomTo] = React.useState("");
  const range = usePeriodRange(period, customFrom, customTo);
  return { period, setPeriod, customFrom, setCustomFrom, customTo, setCustomTo, range };
}
